(function () {
  'use strict';

  function closeMenus(except) {
    document.querySelectorAll('.ge-main-nav details[open]').forEach(function (menu) {
      if (menu !== except) menu.removeAttribute('open');
    });
  }

  function initializeMenu() {
    document.querySelectorAll('.ge-main-nav details').forEach(function (menu) {
      menu.removeAttribute('open');

      var summary = menu.querySelector('summary');
      if (!summary || summary.dataset.geMenuReady === 'true') return;
      summary.dataset.geMenuReady = 'true';

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        var willOpen = !menu.hasAttribute('open');
        closeMenus(menu);
        if (willOpen) menu.setAttribute('open', '');
        else menu.removeAttribute('open');
      });
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.ge-main-nav details')) closeMenus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenus();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMenu);
  } else {
    initializeMenu();
  }

  document.addEventListener('shopify:section:load', initializeMenu);
})();
